<template>
  <Layout>
    <div class="row justify-content-center">
        <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>
    <!-- end row -->
  </Layout>
</template>


<script>
import Layout from '@/components/layouts/auth'
import { authComputed } from '@/store/helpers'
import {version} from '@/../package'

  export default {
    page: {
      title: 'Log in',
      meta: [{ name: 'description' }],
    },
    components: { Layout },
    name: 'Login',
    data() {
      var yup = this.yup
      return {
        appVersion:version,
        webUrl: process.env.VUE_APP_WEB_URL,
        IsSubmit: false,
        values: {
            Email: "",
            Password: "",
        },
        errors: {
            Email: "",
            Password: "",
        },
        FormSchema: yup.object().shape({
          Email: yup.string().email().required(),
          Password: yup.string().min(8).required('กรุณากรอกรหัสผ่าน'),
        })
      };
    },
    mounted(){
        const config = {
            headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
            responseType: 'blob',
        };
        this.axios.get(this.$route.query.url, config)
        .then(function (res) {
            if(res.status == 200){
                let blob = new Blob([res.data], { type: res.data.type })
                let fileUrl = window.URL.createObjectURL(blob)
                window.open(fileUrl,"_self")
            }else{
                this.$swal('เกิดข้อผิดพลาด1');
            }
        })
        .catch(function (error) {
            this.$swal('เกิดข้อผิดพลาด2');
        });
    },
  }
</script>


